import { render } from "./stopPhone.vue?vue&type=template&id=3613fe82&scoped=true"
import script from "./stopPhone.vue?vue&type=script&lang=js"
export * from "./stopPhone.vue?vue&type=script&lang=js"

import "./stopPhone.vue?vue&type=style&index=0&id=3613fe82&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3613fe82"

export default script